.container {
  padding-bottom: 25px;
}

.item-selected .cell-check > div,
.row:hover .cell-check > div {
  visibility: visible;
}

.item-selected .cell-check {
  background-color: var(--main-text);
  border-right-color: var(--hover-light);
  color: white;
}

.item-selected > td,
.row:hover > td {
  background-color: var(--hover-light);
}

.row.item-selected td.cell-check {
  background-color: var(--main-text);
}

.icon {
  display: flex;
  justify-content: center;
}

.cell-check svg {
  fill: currentcolor;
  width: 0.8rem;
}

.cell-check {
  padding: 2px 7px 0;
  cursor: pointer;
}

.cell-check > div {
  visibility: hidden;
}

.bar {
  display: flex;
  align-items: center;
}
